import React from "react";
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from "@headlessui/react";
import classNames from "classnames";
import styles from "./fix-filter-dropdown.module.scss";
import sort from "@/assets/sort.svg";
import down from "@/assets/down.svg";
import check from "@/assets/check.svg";
import { Icon } from "@/elements-react/fix-icon";
import { Gtag } from "@/services/gtag";

export interface FixFilterDropdownOption {
  key: string;
  name: string;
  icon: string;
}

export interface FixFilterDropdownProps {
  value: string;
  options: FixFilterDropdownOption[];
  onChange?: (key: string) => void;
  className?: string;
}

export const FixFilterDropdown: React.FC<FixFilterDropdownProps> = ({ value, options, onChange, className }) => {
  const selected = options.find((o) => o.key === value);

  const handleChange = (val: string) => {
    onChange?.(val);
    Gtag.pushEvent("product_sort_click", { filter: { sortType: val } });
  };

  return (
    <Listbox value={value} onChange={handleChange}>
      {({ open }) => (
        <div className={classNames(styles.root, className, { [styles.open]: open })}>
          <ListboxButton className={styles.button}>
            <Icon src={sort} className={styles.prefixIcon} />
            <span>{selected?.name}</span>
            <Icon src={down} className={styles.expandIcon} />
          </ListboxButton>

          <ListboxOptions
              className={styles.options}
              modal={false}
          >
            {options.map((option) => (
              <ListboxOption
                key={option.key}
                value={option.key}
                className={({ active }) =>
                  classNames(styles.option, {
                    [styles.active]: active,
                    [styles.selected]: option.key === value,
                  })
                }
              >
                {({ selected }) => (
                  <span className={styles.optionContent}>
                    {option.name}
                    {selected && <Icon width={20} src={check} className={styles.checkmark} />}
                  </span>
                )}
              </ListboxOption>
            ))}
          </ListboxOptions>
        </div>
      )}
    </Listbox>
  );
};

export default FixFilterDropdown;
